<template>
    <div :class="['pz-email_alert__container', `pz-email_alert__container__${mode}`]">
        <div class="pz-email_alert__container-title">
            <slot />
        </div>
        <div class="pz-email_alert__container-content">
            <slot name="content" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: 'column',
        },
    },
};
</script>
